module.exports = __webpack_public_path__ + "images/program/encartPixel.1c89d7dc.svg";